module.exports = __webpack_public_path__ + "2acb60f2/img/print-icon.d8dbbca5.svg";